import React, { useEffect, useState } from 'react';
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

function SellerModalConfirm(props) {
  const { model, setOpen } = props;
  const { msg, save } = model;
  const [frozenForComment, setFrozenForComment] = useState('');
  const [type, setType] = useState('SELLER');
  const [sellers, setSellers] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(undefined);

  async function listSellers() {
    let res = await wsGetAll('base/seller?seller_type=S');
    if (res.success) {
      setSellers(res.data);
    }
  }

  async function listSupervisors() {
    let res = await wsGetAll('base/supervisor');
    if (res.success) {
      setSupervisors(res.data);
    }
  }

  async function listUsers() {
    let res = await wsGetAll('oauth/user?role_id=10043'); // Id Supervisor Digital
    if (res.success) {
      setUsers(res.data);
    }
  }

  useEffect(() => {
    setSelected(undefined);
    if (type === 'SELLER') {
      listSellers();
    }

    if (type === 'SUPERVISOR') {
      listSupervisors();
    }

    if (type === 'USER') {
      listUsers();
    }
  }, [type]);

  return (
    <ModalBase
      title={`${msg || 'Activación/Desactivación'} de socio de negocio`}
      model={model}
      setOpen={setOpen}
      fullWidth
      maxWidth="sm"
      onSubmit={async () => {
        return await save(selected?.id || null, frozenForComment, type);
      }}
    >
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Tipo Responsable</InputLabel>
        <Select value={type} onChange={(e) => {
          setType(e.target.value)
          setSelected(undefined);
          }}>
          <MenuItem value="SELLER">Vendedor</MenuItem>
          <MenuItem value="SUPERVISOR">Supervisor</MenuItem>
          <MenuItem value="USER">Usuario Supervisor digital</MenuItem>
        </Select>
      </FormControl>

      {type === 'SELLER' && (
        <SelectAutoComplete
          label="Solicitante"
          textField="SlpName"
          options={sellers}
          selectedOption={selected}
          setSelectedOption={setSelected}
          fullWidth
        />
      )}

      {type === 'SUPERVISOR' && (
        <SelectAutoComplete
          label="Solicitante"
          textField="name"
          options={supervisors}
          selectedOption={selected}
          setSelectedOption={setSelected}
          fullWidth
        />
      )}

      {type === 'USER' && (
        <SelectAutoComplete
          label="Solicitante"
          textField="name"
          options={users}
          selectedOption={selected}
          setSelectedOption={setSelected}
          fullWidth
        />
      )}

      <TextField
        label={`Razón de ${msg || 'Activación/Desactivación'}`}
        fullWidth
        margin="normal"
        value={frozenForComment}
        onChange={(e) => setFrozenForComment(e.target.value)}
        required
      />
    </ModalBase>
  );
}

export default SellerModalConfirm;
